import { VscError } from "react-icons/vsc";
import Modal from "../Modal";

const OrderErrorModal = ({
  close,
  message = "حدث خطأ ما برجاء المحاولة مرة أخري",
}) => {
  return (
    <Modal close={close}>
      <div className="flex flex-col items-center gap-6">
        <VscError size={30} className="text-red-500" />

        <div className="font-bold	text-lg flex flex-col items-center text-red-500">
          <span className="pt-3">{message}</span>
        </div>

        <div className="flex gap-2">
          <button
            className="bg-light-gray text-sm font-bold py-3 px-6 rounded"
            onClick={close}
          >
            حسناً
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default OrderErrorModal;
